import React from "react";
import DatePickerController from "../datePickerController";
import { ASSESSMENT_FIELD_LABELS } from "../../utils/assessmentAdminFieldConfig";
import {
  hasRequestedDraftDateChanged,
  normalizeAdminDateOnly,
} from "../../utils/assessmentAdminRequestedDraftDateHelpers";

/**
 * Requested Draft Report Date row with optional Reason for Change when the date differs.
 */
export default function AssessmentAdminRequestedDraftDateRow({
  updateActive,
  control,
  register,
  watch,
  dateFormat,
  desiredInitialDraftDate,
  hide = false,
}) {
  if (hide) return null;

  const formRequestDate = watch?.("requestDate");
  const formDay = normalizeAdminDateOnly(formRequestDate);
  const showReasonField =
    updateActive &&
    formDay !== null &&
    hasRequestedDraftDateChanged(desiredInitialDraftDate, formRequestDate);

  const readValue =
    desiredInitialDraftDate != null
      ? dateFormat(desiredInitialDraftDate)
      : normalizeAdminDateOnly(formRequestDate)
        ? dateFormat(normalizeAdminDateOnly(formRequestDate))
        : "-";

  return (
    <div className="px-0 py-4">
      <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
        <h2 className="text-sm font-medium text-gray-900">
          {ASSESSMENT_FIELD_LABELS.requestedDraftReportDate}
        </h2>
        <div className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
          {updateActive ? (
            <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:gap-4">
              <div className="min-w-[220px]">
                <DatePickerController
                  control={control}
                  fieldName="requestDate"
                  value={desiredInitialDraftDate}
                  disableMinDate={true}
                />
              </div>
              {showReasonField && (
                <div className="flex-1 min-w-[220px]">
                  <label
                    htmlFor="requestedDraftDateChangeReason"
                    className="block text-sm font-medium text-gray-900 mb-1"
                  >
                    {ASSESSMENT_FIELD_LABELS.requestedDraftDateChangeReason}
                  </label>
                  <textarea
                    id="requestedDraftDateChangeReason"
                    rows={2}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter reason for changing this date"
                    {...register("requestedDraftDateChangeReason")}
                  />
                </div>
              )}
            </div>
          ) : (
            <span>{readValue}</span>
          )}
        </div>
      </div>
    </div>
  );
}
